import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import axios from 'axios';

interface UseApiParams<T, K extends (keyof T)[], E extends Record<string, any>, EKeys extends (keyof E)[]> {
  endpoint: string;
  queryKey: any[];
  params?: object;
  only?: K;
  extra_attributes?: EKeys;
}

export default function useApi<
  TData,
  T = any,
  K extends(keyof T)[] = (keyof T)[],
  E extends Record<string, any> = Record<string, any>,
  EKeys extends (keyof E)[] = (keyof E)[],
>({
  endpoint,
  queryKey,
  params = {},
  only,
  extra_attributes,
  ...queryOptions
}: UseApiParams<T, K, E, EKeys> & Omit<UseQueryOptions<TData>, 'queryFn' | 'queryKey'>) {
  return useQuery<TData>({
    queryFn: () => (
      axios
        .get(endpoint, { params })
        .then(res => res.data.data)
    ),
    queryKey: [...queryKey, params],
    ...queryOptions,
  });
}
